/**
 * Distance with results identical on every JavaScript engine (Phase 10, D90).
 * `Math.hypot` is not required to be correctly rounded, so V8 (Chrome,
 * Cloudflare Workers) and JavaScriptCore (Safari, iOS) may disagree in the
 * last bit — enough to desync a lockstep match. `Math.sqrt`, `+` and `*` are
 * exact IEEE-754 operations. Shared simulation / map code must use this.
 */
export function hyp(dx: number, dy: number): number {
  return Math.sqrt(dx * dx + dy * dy);
}
